import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { StrakitButtonPrefixDirective } from '@ngx-strakit/cdk';
import { StrakitButtonGroupComponent } from '@ngx-strakit/cdk/controls/button-group';
import { LanguageSelectComponent } from './language-select.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MatTooltipModule,
    FormsModule,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
    StrakitButtonGroupComponent,
  ],
  declarations: [
    LanguageSelectComponent,
  ],
  exports: [
    LanguageSelectComponent,
  ],
})
export class LanguageSelectModule { }
